/* Overriding the default content width for an email */
.marketing-outreach-email table {
    width: 100% !important;
}
